import constants from 'scoreboard/components/constants'
import _ from 'lodash'

var calcTypes = {}

calcTypes.showPropertyName = function (type) {
	return typeToProp(type)
}

calcTypes.showPropertyNames = function () {
	return showProps
}

calcTypes.messageCode = function (type) {
	return constants.initiativeCalculationTypes[type].messageCode
}

var nonColorTypes

/*
 	Returns metadata about all valid non-color calculation types. Example:
	{
		type: 'budget-variance-percent'
	 	dataType: 'percent'
		messageCode: 'initiatives.calculation.projectedBudgetVariancePercent'
	}
 */
calcTypes.nonColorTypes = function () {
	if (!nonColorTypes) {
		nonColorTypes = _(constants.initiativeCalculationTypes)
			.toPairs()
			.filter(function (pair) { return pair[0].indexOf('color') === -1 })
			.map(function (pair) {
				return _.extend({ type: pair[0] }, pair[1])
			}).value()
	}

	return nonColorTypes
}

// Note: color intentionally omitted, as it isn't toggled this way
var showProps = _.map([
	'budget', 'budget-remaining', 'budget-spent', 'budget-variance', 'budget-variance-percent',
	'percent-complete', 'percent-time-elapsed', 'projected-budget',	'schedule-variance', 'days-elapsed'
	], typeToProp)

function typeToProp (type) {
	return 'show' + _.upperFirst(_.camelCase(type))
}

export default calcTypes

calcTypes.__filename__ = 'initiatives/initiative-calculation-types.js'
